<div class="modal inmodal fade in parcel-modal create-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title col-sm-8">
                        Booking {{settingsAmenitiesService.bookingRequestModalNotificationType}}
                    </h4>
                </div>
                <div class="modal-body">
                    <div *ngIf="!showEditPanel" (dblclick)="showEditPanelSetter()">
                        <i class="fa fa-pencil pull-right"
                           (click)="showEditPanelSetter()"
                           data-placement="top" data-toggle="tooltip" title="Edit"></i>
                        <h3>Subject</h3>
                        <div>{{originalSubject}}</div>
                        <h3>Email Message</h3>
                        <div class="form-group" id="summernote">{{originalMessage}}</div>
                        <spinner [spinnerShow]="showSpinner"></spinner>
                    </div>
                    <div *ngIf="showEditPanel">
                        <div class="select-container">
                            <span class="select-header">Pre-set Email Template</span>
                            <div>
                                <search-select [ngModel]="emailTemplate"
                                               name="emailTemplate"
                                               (ngModelChange)="changeTemplate($event)"
                                               [data]="emailTemplateSelect(emailTemplates)">
                                </search-select>
                                <spinner [spinnerShow]="showSpinner"></spinner>
                            </div>
                            <div *ngIf="showEditPanel" class="dv-value-edit">
                                <button type="submit" class="check-button" [disabled]="disabledSubmit">
                                    <i class="fa fa-check"></i>
                                </button>
                                <button type="button" (click)="hideEditPanelSetter()">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>
                        <div class="row m-b-sm">
                            <div class="col-md-2">
                                <label>Subject</label>
                            </div>
                            <div class="col-md-10 fourteenPixelText">
                                <input class="form-control"
                                       name="subject"
                                       [(ngModel)]="subject"
                                       [disabled]="emailTemplate != 0" required>
                            </div>
                        </div>
                        <div class="form-group" id="summernote">{{agreementText}}</div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/booking-request-modal/booking-request-modal.component.html